import { createSelector } from 'reselect';
export const getWizard = state => state.wizard;
export const getForecastCategories = createSelector([getWizard], wizard => wizard.forecastCategories);
export const getExistingForecastCategories = createSelector([getWizard], wizard => wizard.existingForecastCategories);
export const getDealStageMappings = createSelector([getWizard], wizard => wizard.dealStageMappings);
export const getIsCreateForecastTypeWizardOpen = createSelector([getWizard], wizard => wizard.isCreateForecastTypeWizardOpen);